module.exports = __webpack_public_path__ + "img/loading.44271f65.gif";